<template>
  <div v-if="showText||!edit" style="width: 100%;height:100%;" @click="onTextClick">
    <span style="display: inline-block;width: 100%">{{ attrs.complexTextConverter? attrs.complexTextConverter(rowData,value) : (value) }}</span>
  </div>
  <div v-else style="margin: 0px;padding: 0px;">
    <el-input ref="elInput" :value="String(value)" :maxlength="attrs.maxLength" @blur="onBlur" @focus="onFocus" @change="onChange" @input="onInput" />
  </div>
</template>

<script>
// import { isNumber } from '@/utils/validate'
export default {
  name: 'CargoCellInput',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: { type: [String, Number], required: false, default: '' },
    field: { type: [String], required: false, default: '' },
    rowData: { type: Object, required: true },
    attrs: { type: Object, required: true },
    edit: { type: Boolean, default: false }
  },
  data() {
    return {
      showText: true,
      wait: 100,
      neeDInitData: true,
      loading: false,
      lastValue: this.value // 上次的值
    }
  },
  mounted() {
    // console.log('渲染啦啦啦 ffield', this.field)
  },
  methods: {
    onTextClick() {
      if (this.edit) {
        this.showText = false
        this.toSetShowInputVal()
        this.$nextTick(() => {
          this.$refs.elInput.focus()
        })
      }
    },
    toSetShowInputVal() { // 处理数字在input框中的初始值
      if (this.attrs.complexTextConverter) { // // todo-shengsheng  Desc: 需要配合attr 的type{number,string} 使用，for strong
        const richInputV = this.attrs.complexTextConverter(this.rowData, this.value)
        if (richInputV === undefined || richInputV === '') {
          return
        }
        // const richInputV = '1.000'
        console.log('richInputV', richInputV)
        const numArr = richInputV.split('.')
        const integer = numArr[0]
        let decimals = null
        if (numArr.length > 1) {
          decimals = numArr[numArr.length - 1]
        }
        console.log('integer', integer, decimals)
        const pureInteger = this.$numeral(integer).value()
        if (pureInteger !== null) {
          let showInputV
          if (decimals !== null) {
            showInputV = Number(pureInteger + ('.' + decimals)).toFixed(decimals.length)
          } else {
            showInputV = Number(pureInteger)
          }
          console.log('showInputV', showInputV)
          this.$emit('input', showInputV)
        }
      }
    },
    onInput(val) {
      let emitVal = val
      if (val && this.attrs.type === 'number') {
        if (emitVal > 999999999999999) {
          emitVal = 999999999999999
        }
        if (emitVal < -999999999999999) {
          emitVal = -999999999999999
        }
      }
      this.$emit('input', emitVal)
    },
    onBlur() {
      this.showText = true
    },
    onFocus(e) {
      e.target.select()
    },
    onChange(val) {
      console.log('onChange', val)
      if (!this.attrs.checkInput || this.attrs.checkInput(val)) {
        if (typeof val === 'string') {
          let newVal = val
          if (this.attrs.isUppercase) {
            newVal = newVal.toUpperCase()
          }
          if (this.attrs.isTrim) {
            newVal = newVal.trim()
          }
          if (newVal !== val) {
            this.$emit('input', newVal)
          }
        }
        this.$emit('change', val)
        this.lastValue = val
      } else {
        // 输入不合法，回退最近一次 正确值
        this.$emit('input', this.lastValue)
      }
    }
  }
}
</script>
